<template>
	<div class="expert-score">
		<div class="container-fluid">
			<div class="wrapper" style="max-width:90%">
				<div class="content-page">
					<div class="content">
						<div class="row mb-1">
							<div class="col-xl-6">立项审核</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
								<Breadcrumb></Breadcrumb>
							</div>
						</div>
						<div class="card">
							<div class="card-body">
								<div class="mb-2">
									<el-input class="mr-2 mb-1" v-model="query.name" placeholder="请输入课题名称" size="small"
										style="width: 180px"></el-input>
									<el-cascader class="mr-2 mb-1" :options="areaOptions"
										:props="{ expandTrigger: 'hover', checkStrictly: true, label: 'name', value: 'id' }"
										placeholder="-请选择所属区域-" clearable filterable size="small"
										@change="cascaderChange">
										<template slot-scope="{ node, data }">
											<span>{{ data.name }}</span>
											<span v-if="!node.isLeaf">({{ data.children.length }})</span>
										</template>
									</el-cascader>
									<el-select class="mr-2 mb-1" v-model="query.learningTypeId" placeholder="-请选择所属学段-"
										clearable size="small">
										<el-option v-for="item in stageOptions" :key="item.id" :label="item.name"
											:value="item.id"></el-option>
									</el-select>
									<!-- <el-cascader class="mr-2 mb-1" :options="subjectTypeOptions"
										:props="{ expandTrigger: 'hover', label: 'name', value: 'id' }"
										placeholder="-课题类别-" clearable filterable size="small"
										@change="cascaderSubjectTypeChange">
										<template slot-scope="{ node, data }">
											<span>{{ data.name }}</span>
											<span v-if="!node.isLeaf">({{ data.children.length }})</span>
										</template>
									</el-cascader> -->
									<el-select class="mr-2 mb-1" v-model="query.projectState" placeholder="-立项状态-"
										clearable size="small">
										<el-option v-for="item in projectStateOptions" :key="item.value"
											:label="item.label" :value="item.value"></el-option>
									</el-select>
									<!-- 新增负责人查询条件 -->
									<el-input class="mr-2 mb-1" v-model="query.oneEmceeName" placeholder="请输入负责人姓名" size="small"
										style="width: 180px"></el-input>
									<el-button class="ml-2 mb-1" type="success" size="small" @click="searchData">查询
									</el-button>
									<!-- <div class="mt-2" style="text-align:right">
                    <el-button class="mb-1" type="primary" icon="el-icon-upload" size="small" @click="exportExcel">导出Excel</el-button>
                  </div> -->
								</div>
								<el-table id="exportTab" :header-cell-style="tableHeaderStyle" ref="multipleTable"
									:data="list" tooltip-effect="dark" style="width: 100%" border
									@selection-change="handleSelectionChange">
									<el-table-column type="selection" :selectable="isDisabled" width="40">
									</el-table-column>
									<!-- <el-table-column prop="id" label="序号" min-width="50"></el-table-column> -->
									<el-table-column prop="declareName" label="课题名称" min-width="150"></el-table-column>
									<!-- <el-table-column prop="projectTypeName" label="课题类别" sortable min-width="100"></el-table-column> -->
									<el-table-column prop="learningTypeName" label="学段" sortable width="80">
									</el-table-column>
									<el-table-column prop="disciplineName" label="学科" sortable width="80">
									</el-table-column>
									<el-table-column prop="unitName" label="单位" sortable min-width="80">
									</el-table-column>
									<el-table-column prop="oneEmceeName" label="负责人" sortable min-width="90">
									</el-table-column>
									<el-table-column prop="internAvgScore" label="初评分" sortable width="60">
									</el-table-column>
									<el-table-column prop="internResults" label="初评结果" sortable width="80">
										<template slot-scope="scope">
											<span v-if="scope.row.internResults === 0">不建议立项</span>
											<span v-if="scope.row.internResults === 1">建议立项</span>
										</template>
									</el-table-column>
									<el-table-column prop="reviewAvgScore" label="复评分" sortable width="60">
									</el-table-column>
									<el-table-column prop="reviewResults" label="复评结果" sortable width="80">
										<template slot-scope="scope">
											<span v-if="scope.row.reviewResults === 0">不建议立项</span>
											<span v-if="scope.row.reviewResults === 1">建议立项</span>
										</template>
									</el-table-column>
									<el-table-column prop="finalAvgScore" label="终评分" sortable min-width="60">
									</el-table-column>
									<el-table-column prop="finalResults" label="终评结果" sortable min-width="100">
										<template slot-scope="scope">
											<span v-if="scope.row.finalResults === 0">不建议立项</span>
											<span v-if="scope.row.finalResults === 1">建议立项</span>
										</template>
									</el-table-column>
									<el-table-column prop="projectState" label="立项状态" width="80">
										<template slot-scope="scope">
											<span style="color:#0acf97" v-if="scope.row.projectState === 1">已立项</span>
											<span v-else-if="scope.row.projectState === 0" style="color:red">不予立项</span>
											<span v-else style="color:#999">未操作</span>
										</template>
									</el-table-column>
								</el-table>
								<div class="mt-2">
									<el-button class="mb-1" type="primary" icon="el-icon-upload" @click="exportExcel">
										导出Excel</el-button>
									<el-button class="mr-1" type="primary" @click="toUpdate(1)">批准立项</el-button>
									<el-button class="mr-1" type="warning" @click="toUpdate(0)">不予立项</el-button>
								</div>
								<!-- 分页器 -->
								<div class="text-right mt-2">
									<el-pagination layout="total, sizes, prev, pager, next, jumper" background
										:current-page="query.pageNumber" :page-sizes="[10, 50, 100, 200]"
										:page-size="query.pageSize" :total="total" @size-change="handleSizeChange"
										@current-change="handlePageChange"></el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="请选择立项后的课题类别" :visible.sync="changeTopicTypeDialogVisible" width="30%"
			:before-close="handleClose">
			<el-form :model="queryUpdate" :rules="queryUpdateRules" ref="queryUpdateRef" label-width="100px"
				class="demo-ruleForm">
				<el-form-item label="课题类别" prop="projectTypeId">
					<el-select v-model="queryUpdate.projectTypeId" placeholder="请选择" @change="topicTypeChange">
						<el-option v-for="item in topicTypeList" :key="item.id" :label="item.dictName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="changeTopicTypeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAreaTree,
		getPlatformInformationData
	} from '@/api/after/systemManagement';
	import {
		getprojectDeclareQuasiList,
		auditProject
	} from '@/api/after/proposedProject';
	import {
		getTopicCateById
	} from '@/api/after/projectApplication.js'
	import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
	import FileSaver from 'file-saver';
	import XLSX from 'xlsx';
	export default {
		name: 'proposedProject',
		components: {
			Breadcrumb
		},
		data() {
			return {
				changeTopicTypeForm: {},
				changeTopicTypeRules: {},
				changeTopicTypeDialogVisible: false, //改变课题类别对话框
				tableHeaderStyle: {
					backgroundColor: '#3083c5',
					color: '#fff'
				},
				tableSort: {
					prop: 'projectTypeName',
					prop: 'learningTypeName',
					prop: 'disciplineName',
					prop: 'unitName',
					prop: 'oneEmceeName',
					prop: 'internNumber',
					prop: 'internResults'
				},
				areaOptions: [], //区域列表
				subjectTypeOptions: [], //课题类别
				//学段列表
				stageOptions: [{
						id: '0',
						name: '幼儿园'
					},
					{
						id: '1',
						name: '小学'
					},
					{
						id: '2',
						name: '初中'
					},
					{
						id: '3',
						name: '高中'
					},
					{
						id: '4',
						name: '中/高职'
					},
					{
						id: '5',
						name: '其他'
					}
				],
				// 立项状态
				projectStateOptions: [{
					value: 0,
					label: '不予立项'
				}, {
					value: 1,
					label: '已立项'
				}],
				query: {
					name: '', //课程名
					regionId: null, //区域id
					oneEmceeName:null,//负责人
					learningTypeId: null, //学段id
					projectState: null, //立项状态（0：不予立项,1:已立项）
					projectTypeId: null, //课题类别id
					projectId: JSON.parse(sessionStorage.getItem('projectData')).id || null, //项目ID
					pageNumber: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				multipleSelection: [], //被选中的项
				queryUpdate: {
					ids: [],
					type: 1,
					"projectTypeId": null,
					"projectTypeName": null,
				},
				queryUpdateRules: {
					projectTypeId: [{
						required: true,
						message: '请选择课题类别',
						trigger: 'change'
					}]
				},
				topicTypeList: [], //该项目下课题类别列表
				// curOperateType:0,//当前操作类型1为批准0为不批准
			};
		},
		mounted() {
			this.getData();
			this.getAreaTree();
			this.getPlatformInformationData();
			this.getTopicCateById()
		},
		methods: {
			// 课题类别选择
			topicTypeChange(id) {
				let topicTypeObj = this.topicTypeList.find(item => {
					return item.id == id
				})
				this.queryUpdate.projectTypeName = topicTypeObj.dictName
				console.log('选择课题列表后数据', this.queryUpdate);
			},
			// 通过项目ID获取课题类别列表
			async getTopicCateById() {
				let projectId;
				if (sessionStorage.getItem('projectData')) {
					projectId = JSON.parse(sessionStorage.getItem('projectData')).id
				}
				if (projectId) {
					const res = await getTopicCateById(projectId)
					if (res.code == 200) {
						this.topicTypeList = res.data
					} else {
						this.$message.error(res.data)
					}
				}
			},
			// 获取数据列表
			getData(isNum) {
				if (isNum) this.query.pageNumber = 1;
				getprojectDeclareQuasiList(this.query).then(res => {
					if (res.code == 200) {
						this.list = res.data.records;
						this.total = res.data.total;
					} else {
						this.$message.error(res.data);
					}
				});
			},
			// 获取区域树
			getAreaTree() {
				getAreaTree().then(res => {
					if (res.code == 200) {
						this.areaOptions = res.data;
					} else {
						this.$message.error(res.data);
					}
				});
			},
			// 获取课题类别
			getPlatformInformationData() {
				getPlatformInformationData(1).then(res => {
					if (res.code == 200) {
						this.subjectTypeOptions = res.data;
					} else {
						this.$message.error(res.data);
					}
				});
			},
			// 搜索
			searchData() {
				this.getData(true);
			},
			//区域筛选
			cascaderChange(e) {
				let num = null;
				e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
				this.query.regionId = num;
			},
			//课题类别筛选
			cascaderSubjectTypeChange(e) {
				let num = null;
				e.length <= 0 ? (num = null) : (num = e[e.length - 1]);
				this.query.projectTypeId = num;
			},
			// 配置表格禁止选中项
			isDisabled(row) {
				if (row.projectState === 1 || row.projectState === 0) {
					return 0;
				}
				return 1;
			},
			// 选择需要操作的项
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 批准立项
			toUpdate(type) {
				if (this.multipleSelection.length <= 0) {
					this.$message.warning('请先选择课题!')
					return
				}

				this.queryUpdate.type = type;
				this.queryUpdate.ids = this.multipleSelection.map(item => {
					return item.id;
				});

				if (type === 0) {
					this.$confirm('确定要将所选课题批准为 “不予立项” 吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.queryUpdate.projectTypeId = null
						this.queryUpdate.projectTypeName = null
						this.auditProject();
					});
				} else if (type === 1) {
					this.changeTopicTypeDialogVisible = true
					// this.auditProject();
				}

			},
			// 批准立项课题类别选择确定对话框
			confirm() {
				this.$refs.queryUpdateRef.validate(valid => {
					if (valid) {
						this.$confirm(`确定要对所选择的课题立项为${this.queryUpdate.projectTypeName}吗？`, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.changeTopicTypeDialogVisible = false
							this.auditProject();
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消'
							});
						});
					}
				})
			},
			//立项或者不立项操作
			auditProject() {
				auditProject(this.queryUpdate).then(res => {
					if (res.code == 200) {
						this.$message.success('操作成功');
					} else {
						this.$message.error(res.data);
					}
					this.getData();
				});
			},
			// 导出表格
			exportExcel() {
				var xlsxParam = {
					raw: true
				};
				var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam);
				var wbout = XLSX.write(wb, {
					bookType: 'xlsx',
					bookSST: true,
					type: 'array'
				});
				try {
					FileSaver.saveAs(new Blob([wbout], {
						type: 'application/octet-stream'
					}), '立项审核表.xlsx');
				} catch (e) {
					if (typeof console !== 'undefined') {
						console.log(e, wbout);
					}
				}
				return wbout;
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageNumber = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.getData(true);
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			}
		}
	};
</script>

<style scoped>
	.card-body {
		padding: 1.5rem 0;
	}

	.mb-2,
	.mt-2 {
		padding: 0 1.5rem;
	}

	.file_box {
		position: relative;
		display: flex;
		align-items: center;
		border: 1px dashed #d9d9d9;
		height: 30px;
		padding: 0 20px;
		cursor: pointer;
		max-width: calc(100% - 150px);
		margin: 5px 0;
	}

	.file_box p {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 450px;
		margin-bottom: 0;
		line-height: normal;
	}

	.close_btn {
		position: absolute;
		top: -8px;
		right: -8px;
	}

	.wrap {
		background: #fafbfe;
		padding: 30px;
	}

	.con {
		min-height: 500px;
		background: #fff;
		padding: 30px;
		border-radius: 5px;
	}

	/deep/.el-table th>.cell {
		text-align: center;
	}

	/deep/.el-table .cell {
		text-align: center;
	}
</style>
